/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';

posthog.init(environment.posthog.key, {
  api_host: environment.posthog.host,
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well,
  capture_pageview: false,
  capture_pageleave: true,
});

Sentry.init({
  dsn: 'https://49563711d674f2417661566867a0f7b4@o4508669950885888.ingest.de.sentry.io/4508669959405648',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.unicity\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
